export const QuotationBillingValidation = (formData) => {
    const errors = {};
   
    if (!formData.vc_FullName || formData.vc_FullName==="") {
        errors.vc_FullName = 'This field is required';
    }
    if (!formData.vc_Address1 || formData.vc_Address1==="") {
        errors.vc_Address1 = 'This field is required';
    }
     
    return errors;
};
